import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import React, { Component } from 'react';
import { Row, Col, Menu } from 'antd';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { storeArq } from 'correos-arq-utils';
;
;

var MHorizontal = /*#__PURE__*/function (_Component) {
  _inherits(MHorizontal, _Component);

  var _super = _createSuper(MHorizontal);

  function MHorizontal(props) {
    var _this;

    _classCallCheck(this, MHorizontal);

    _this = _super.call(this, props); //se carga el storeArq en el componente

    storeArq.load(); // @ts-ignore: Se guarda en una variable localStorage para uso en PrivateRoute las rutas internas de la app, sin el index ("inicio")

    storeArq.data.auth.propertiesAcWeb = _toConsumableArray(new Set(_this.props.pathRoutes.filter(function (items) {
      return items.label !== 'router_routes.home';
    }).filter(function (items) {
      return items["public"] === true;
    }).map(function (rutas) {
      return rutas.path;
    }))); //guardar los datos en el storeArq

    storeArq.save();
    _this.state = {
      auth: storeArq.data.auth
    };
    return _this;
  }

  _createClass(MHorizontal, [{
    key: "render",
    value: function render() {
      var acciones = this.state.auth.userInfo.accionesWeb;
      var props = this.props;
      return /*#__PURE__*/React.createElement("div", {
        className: "MHorizontal"
      }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        span: 1
      }), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Menu, {
        mode: "horizontal",
        theme: "dark",
        className: "menu menu-horizontal"
      }, props.items !== undefined && props.items // filtrar por "sin Inicio" --> por el icono en la barra de herramientas
      // .filter(function (itemsMenu: TipoPathRoutes) {
      //   return itemsMenu.label !== 'router_routes.home';
      // })
      // filtrar por "acciones web" - metodo "includes" no soportado para IE
      .filter(function (itemsMenu) {
        return acciones.map(function (ac) {
          return ac.path;
        }).includes(itemsMenu.path);
      }) //mapear como menu items del nav los items resultantes del filtro
      //importante: el formato arrow function !¡
      .map(function (itemsMenu, i) {
        return /*#__PURE__*/React.createElement(Menu.Item, {
          key: i,
          onClick: function onClick() {
            props.clickMenu && props.clickMenu();
            props.clickHome(false);
          },
          className: props.areWeHome ? 'noBackgroundColor menu-item' : 'menu-item'
        }, /*#__PURE__*/React.createElement(Link, {
          to: itemsMenu.path,
          className: props.areWeHome ? 'noBackgroundColor' : ''
        }, props.t(itemsMenu.label)));
      })))));
    }
  }]);

  return MHorizontal;
}(Component);

export default withTranslation()(MHorizontal);